import { render } from "./ChoseSubChapter.vue?vue&type=template&id=476d0a54"
import script from "./ChoseSubChapter.vue?vue&type=script&lang=js"
export * from "./ChoseSubChapter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__